import '../sass/style.sass';
import {scrollToTop} from "./modules/scrollToTop";
import {toggleActive} from "./modules/toggleActive";
import {getResources} from "./modules/getResources";

document.addEventListener('DOMContentLoaded', () => {

  toggleActive(Array.prototype.slice.call(document.querySelectorAll('.js-toggle-active'), 0));

  let last_known_scroll_position = 0;
  let ticking = false;
  window.addEventListener('scroll', function (e) {
    last_known_scroll_position = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const $top = document.getElementById('totop');
        if (last_known_scroll_position > 100) {
          $top.classList.add('ease-in');
        } else if ($top.classList.contains('ease-in') && !$top.classList.contains('ease-out')) {
          $top.classList.add('ease-out');
        }
        ticking = false;
      });
    }
    ticking = true;
  });
  scrollToTop(Array.prototype.slice.call(document.querySelectorAll('.js-scroll-to-top'), 0));

  Array.prototype.slice.call(document.querySelectorAll('.modal'), 0).forEach($modal => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (document.querySelector('.modal.is-active')) {
          document.body.classList.add('html-clipped');
        } else {
          document.body.classList.remove('html-clipped');
        }
      });
    });
    observer.observe($modal, {attributes: true});
  });

  if (document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, '$1').length > 0) {
    Array.prototype.slice.call(document.querySelectorAll('.js-member-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  } else {
    Array.prototype.slice.call(document.querySelectorAll('.js-nonmember-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  }

  getResources(Array.prototype.slice.call(document.querySelectorAll('.js-get-resources'), 0));

  if (navigator.userAgent.match(/DARAPP/)) {
    Array.prototype.slice.call(document.querySelectorAll('.js-detect-device'), 0).forEach($el => {
      $el.classList.add('is-bbclapp2');
    });
    Array.prototype.slice.call(document.querySelectorAll('.js-bcapp-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  } else {
    Array.prototype.slice.call(document.querySelectorAll('.js-bcweb-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  }
});
